import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/seo/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { SITE_ORIGIN } from "@/lib/leaks";
import { site } from "@/mocks/site";
import Positioning from "@/pages/about/components/Positioning";
import BrandStory from "@/pages/about/components/BrandStory";
import Principles from "@/pages/about/components/Principles";
import AboutVoices from "@/pages/about/components/AboutVoices";

export default function About() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: `关于${site.name}`,
      url: `${SITE_ORIGIN}/about`,
      description: site.intro,
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.name,
      url: SITE_ORIGIN,
      email: site.email,
      slogan: site.slogan,
      description: site.mission,
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: SITE_ORIGIN },
        { "@type": "ListItem", position: 2, name: "关于我们" },
      ],
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="关于我们 | 蝌蚪爆料内容原则与网站定位"
        description="了解蝌蚪爆料的品牌定位、发展理念与内容原则：来源可追溯、区分事实与推测、尊重当事人、持续跟进，让每条爆料都能被看懂。"
        keywords="蝌蚪爆料,关于蝌蚪爆料,蝌蚪爆料内容原则,蝌蚪爆料定位,蝌蚪爆料投稿"
        path="/about"
        jsonLd={jsonLd}
      />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1200px] px-4 py-10 md:px-8 md:py-16">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-4 max-w-3xl font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            关于蝌蚪爆料
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            {site.intro}
          </p>
        </div>
      </section>

      <Positioning />
      <BrandStory />
      <Principles />
      <AboutVoices />

      <section className="bg-secondary-950 py-14 text-secondary-100 md:py-20">
        <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-8 px-4 md:grid-cols-2 md:px-8">
          <div>
            <p className="text-xs font-medium tracking-widest text-accent-400">CONTACT · 联系方式</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              有线索，或者想聊聊？
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200/90">
              无论是一条现场线索、一处内容纠错，还是合作意向，都欢迎联系我们。我们会在工作日内逐条查看并回复。
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-secondary-800 bg-secondary-900/60 p-5">
              <p className="text-xs text-secondary-300/80">内容与投稿邮箱</p>
              <p className="mt-2 break-all font-heading text-base font-semibold text-background-50">
                {site.submitEmail}
              </p>
            </div>
            <div className="rounded-lg border border-secondary-800 bg-secondary-900/60 p-5">
              <p className="text-xs text-secondary-300/80">合作与反馈邮箱</p>
              <p className="mt-2 break-all font-heading text-base font-semibold text-background-50">
                {site.email}
              </p>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              前往联系与投稿页面
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}